export default {
	path: '/speaker-cctv',
	redirect: '/speaker-cctv',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'speakerCctvHome',
			component: () => import('@/views/mng/SpeakerCctv'),
		},
	],
};
